// Loading.tsx
type LoadingProps = { label?: string };

const RING_PATH =
  'M80.7,15.7c-0.4,2.9-4.9,7-12.1,11.3c-6.5,3.9-15.1,8-24.8,11.7c-9.3,3.5-18.2,6-25.4,7.3c-8.8,1.6-15.2,1.5-17.5-0.4c-0.3-0.3-0.6-0.6-0.7-1c-1.1-2.9,3.7-7.6,12.2-12.7c0,0-1,7.5,28-2.8C69.4,18.7,64,12.8,64,12.8c9.2-1.5,15.5-1.1,16.6,1.7C80.7,14.9,80.7,15.3,80.7,15.7z';

// The ring outline splits at its two tips into a near-side sweep (below/in
// front of the sphere) and a far-side sweep (behind the sphere), so the
// traveling light can be drawn in front of the planet disc for one and
// behind it for the other.
const RING_PATH_NEAR =
  'M80.7,15.7c-0.4,2.9-4.9,7-12.1,11.3c-6.5,3.9-15.1,8-24.8,11.7c-9.3,3.5-18.2,6-25.4,7.3c-8.8,1.6-15.2,1.5-17.5-0.4';
const RING_PATH_FAR =
  'M0.9,45.6c-0.3-0.3-0.6-0.6-0.7-1c-1.1-2.9,3.7-7.6,12.2-12.7c0,0-1,7.5,28-2.8C69.4,18.7,64,12.8,64,12.8c9.2-1.5,15.5-1.1,16.6,1.7C80.7,14.9,80.7,15.3,80.7,15.7';

export default function Loading({ label = 'Loading' }: LoadingProps = {}) {
  return (
    <div
      className="my-8 flex h-16 items-center justify-center sm:h-20"
      role="status"
      aria-label={label}
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 80.7 56.5"
        className="ultiverse-loader h-full w-auto"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Light on the far sweep, laid down first so the planet can occlude it */}
        <path
          className="ultiverse-loader-ring-light ultiverse-loader-ring-light-far"
          d={RING_PATH_FAR}
          pathLength={100}
        />

        {/* Opaque planet disc: hides the far light where it passes behind the sphere */}
        <circle className="ultiverse-loader-planet" cx="40.35" cy="28.25" r="27.6" />

        {/* Sphere outline */}
        <circle cx="40.35" cy="28.25" r="27.6" opacity="0.55" />

        {/* Light on the near sweep, always drawn in front of the planet */}
        <path
          className="ultiverse-loader-ring-light ultiverse-loader-ring-light-near"
          d={RING_PATH_NEAR}
          pathLength={100}
        />

        {/* Ring outline (static track), always drawn on top */}
        <path className="ultiverse-loader-ring-track" d={RING_PATH} />
      </svg>
    </div>
  );
}
